import { getBgStatusColor, getBorderStatusColor, getTextStatusColor } from '@/app/(root)/utils';
import type { IZoneStatus } from '@/data';
import type { STATUS } from '@/enums';
import { cn } from '@/libs';
interface IServiceHeaderProps {
  Icon: React.ElementType;
  status: STATUS;
  zones: [string, IZoneStatus][];
}
export const ServiceHeader: React.FC<IServiceHeaderProps> = ({
  zones,
  status,
  Icon
}) => <div className='mb-2 flex items-center justify-between'>
    <div className='flex items-center gap-2'>
      <div className='text-gray-600 dark:text-gray-300'>
        <Icon className='size-5' />
      </div>
      <div className={cn('h-2 w-2 rounded-full', getBgStatusColor(status, false))} />
    </div>
    <ul className='flex items-center gap-1 text-xs'>
      {zones.map(([key, value]) => <li className={cn('rounded-sm border border-health-operational px-2 py-px leading-none', getBgStatusColor(value.status), getTextStatusColor(value.status), getBorderStatusColor(value.status))} key={key}>
          {key}
        </li>)}
    </ul>
  </div>;